const digest = '6e2b7ed91a049854de344be2f9dc28f157ee31874aca0659d06eaf39e877fc9c';
const css = `._tooltip_uc8vm_1{border-radius:.5rem;top:3.25rem}._tooltipVariant_uc8vm_11,._tooltip_uc8vm_1{max-width:90vw;outline:none;position:absolute;width:20rem;z-index:80}._tooltipVariant_uc8vm_11{border:1px solid #e0e0e0;border-radius:1rem;min-width:326px;top:5.5rem}@media (max-width:799px){._tooltipVariant_uc8vm_11,._tooltip_uc8vm_1{border-radius:0;bottom:0;left:0!important;max-width:none;position:fixed;right:0;top:0;width:auto;z-index:var(--above_C2C,109000)}}._tooltipBody_uc8vm_47{flex:1;overflow-y:auto}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'tooltip': '_tooltip_uc8vm_1', 'tooltipVariant': '_tooltipVariant_uc8vm_11', 'tooltipBody': '_tooltipBody_uc8vm_47' };
export const tooltip = '_tooltip_uc8vm_1';
export const tooltipVariant = '_tooltipVariant_uc8vm_11';
export const tooltipBody = '_tooltipBody_uc8vm_47';
export { css, digest };